import { defineComponent } from 'navigation-components/platform/models';
import { getStyle } from './internal/get-style';
import { getPortalId } from '../../common/utils';
import { args } from '../../common/args';
import { capabilities } from '../../capabilities';
import { Tags } from '../constants';
import { GROWTH_ONBOARDING_NEXT_ACTION_MODAL_COMPONENT } from '../constants';
import { getInitialProps } from './internal/get-initial-props';
export const GROWTH_ONBOARDING_NEXT_ACTION_MODAL_IFRAME_ID = 'growth-onboarding-next-action-modal-iframe';
export const growthOnboardingNextActionModalComponentDef = defineComponent(GROWTH_ONBOARDING_NEXT_ACTION_MODAL_COMPONENT, {
  name: GROWTH_ONBOARDING_NEXT_ACTION_MODAL_COMPONENT,
  path: `/growth-onboarding-next-action-modal/${getPortalId()}`,
  capabilities: [capabilities.HIDE_COMPONENT_CAP.getName()],
  initiallyFullscreen: true,
  tags: [Tags.MODAL],
  iframeProps: {
    id: GROWTH_ONBOARDING_NEXT_ACTION_MODAL_IFRAME_ID,
    style: getStyle()
  },
  propsSchema: {
    hostAppName: args.string(),
    modalKey: args.string()
  },
  initialProps: getInitialProps()
});